import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { memo } from "react";
export const PublicGalleryBoardAncestors = /*#__PURE__*/ memo((param)=>{
    let { ancestors } = param;
    const nearestAncestorTitle = ancestors[ancestors.length - 1].title;
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: ancestors.length > 1 ? "\xb7\xb7\xb7 / ".concat(nearestAncestorTitle) : nearestAncestorTitle
    });
});
PublicGalleryBoardAncestors.displayName = "PublicGalleryBoardAncestors";
